import type {ManifestFeatureComponentStageGfpp, ManifestFeatureGfppDesktopConfig} from '@wix/document-services-types'
import type {ManifestActionValue} from './types'
import {merge, omitBy} from 'lodash'
import {ActionsHelpers} from './ActionsHelpers'
import {COMP_TYPES} from '../../../../constants/constants'
import type {ComponentRepository} from '../../repository/ComponentRepository'
import {ActionExecutionBuilder} from './ActionExecutionBuilder'
import type {DataModelAPI} from '../../../dataModel/dataModel'

export abstract class BaseActionsBuilder<TOutput> {
    protected readonly actionExecutionBuilder: ActionExecutionBuilder

    constructor(
        protected readonly componentType: string,
        protected readonly gfpp: ManifestFeatureComponentStageGfpp | undefined,
        dataModelAPI: DataModelAPI
    ) {
        this.actionExecutionBuilder = new ActionExecutionBuilder(dataModelAPI)
    }

    protected abstract pickSupportedActions(data: ManifestFeatureGfppDesktopConfig): Record<string, ManifestActionValue>

    protected abstract transformToBuilderActions(data: Record<string, ManifestActionValue>): TOutput

    private mergeDafaultsIfNeeded = (
        componentType: ReturnType<ComponentRepository['getComponentType']>,
        gfppFromStage: ManifestFeatureGfppDesktopConfig | undefined = {}
    ): ManifestFeatureGfppDesktopConfig => {
        switch (componentType) {
            case COMP_TYPES.APP_WIDGET_TYPE:
                return merge({}, ActionsHelpers.INITIAL_GFPP_STATE, gfppFromStage)
            default:
                return gfppFromStage
        }
    }

    private filterHidden({iconButtons, ...rest}: ManifestFeatureGfppDesktopConfig) {
        const filterPredicate = (value?: ManifestActionValue) => ActionsHelpers.isUserForgotToBindAction(value)

        return {
            ...omitBy(rest, filterPredicate),
            ...(iconButtons ? {iconButtons: omitBy(iconButtons, filterPredicate)} : {})
        }
    }

    public build = (): TOutput => {
        const merged = this.mergeDafaultsIfNeeded(this.componentType, this.gfpp?.desktop)
        const filtered = this.filterHidden(merged)
        const picked = this.pickSupportedActions(filtered)
        return this.transformToBuilderActions(picked)
    }
}
